// Backs the dropzones rendered by the file_dropzone widget in
// src/hub/components/form_widgets.py: a <file-attachment input="..."> zone
// that lists the accepted file names in its <pre> and puts the files in the
// referenced hidden file input, for submission as a regular form upload.
//
// Imported for its side effects in main.ts; the single document-level
// listener covers all dropzones, including htmx-swapped ones.
import "@github/file-attachment-element";
import type { Attachment } from "@github/file-attachment-element";

declare global {
  interface GlobalEventHandlersEventMap {
    "file-attachment-accepted": CustomEvent<{ attachments: Attachment[] }>;
  }
}

// The event bubbles and fires with the complete attachment list, after the
// library has finished traversing dropped directories.
document.addEventListener("file-attachment-accepted", (event) => {
  const dropzone = event.target;
  if (!(dropzone instanceof Element)) return;
  const { attachments } = event.detail;

  // Show the accepted file names inside the dropzone.
  const pre = dropzone.querySelector("pre");
  if (pre) {
    pre.textContent = attachments.map((a) => a.file.name).join("\n");
  }

  const input = document.getElementById(dropzone.getAttribute("input") ?? "");
  if (!(input instanceof HTMLInputElement)) return;

  const dataTransfer = new DataTransfer();
  for (const attachment of attachments) {
    dataTransfer.items.add(attachment.file);
  }

  // For click-to-select uploads, the library clears the file input right
  // after dispatching this event, which would wipe a synchronous assignment.
  // Defer one microtask so our files land after the clear.
  queueMicrotask(() => {
    input.files = dataTransfer.files;
  });
});
